export const armoptions = [
	{ value: 'Black', label: 'Black', parm: 'arm' },
	{ value: 'Blue', label: 'Blue', parm: 'arm' },
	{ value: 'Gold', label: 'Gold', parm: 'arm' },
	{ value: 'Red', label: 'Red', parm: 'arm' },
	{ value: 'Tribe', label: 'Tribe', parm: 'arm' },
];